import { render } from "./ListiniPage.vue?vue&type=template&id=908ae8aa&scoped=true"
import script from "./ListiniPage.vue?vue&type=script&lang=js"
export * from "./ListiniPage.vue?vue&type=script&lang=js"

import "@/css/StockPage.css?vue&type=style&index=0&lang=css&external"
import "./ListiniPage.vue?vue&type=style&index=1&id=908ae8aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908ae8aa"]])

export default __exports__